import { FC } from 'react';
import Link from 'next/link';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { getCollectionNameByDtoId, useSJDatabase } from '@/shared/lib/sj-orm';

import { parseRichText } from '../helpers';
import { Token } from '../types';

type RichTextProps = {
  input: string;
};

export const RichText: FC<RichTextProps> = ({ input }) => {
  const sjDb = useSJDatabase();
  const tokens = parseRichText(input);

  const renderToken = (token: Token, index: number) => {
    switch (token.type) {
      case 'text':
        return <span key={index}>{token.value}</span>;

      case 'link':
        return (
          <StyledLink key={index} href={token.url} target="_blank" rel="noreferrer">
            {token.children.map(renderToken)}
          </StyledLink>
        );

      case 'template': {
        const collectionName = getCollectionNameByDtoId(token.id);
        if (!collectionName || !token.id) return null;

        const item = sjDb.collections[collectionName]?.findById(token.id) as Record<
          string,
          unknown
        >;
        const value = item?.[token.value] as string;

        return <span key={index}>{value}</span>;
      }

      default:
        return null;
    }
  };

  return tokens.map(renderToken);
};

const StyledLink = styled(Link)`
  &&& {
    color: ${COLORS.systemSky200};
  }
`;
